export const API_REQUEST_STARTED = 'API_REQUEST_STARTED';
export const API_REQUEST_FINISHED = 'API_REQUEST_FINISHED';
export const API_REQUEST_ERROR = 'API_REQUEST_ERROR';
export const API_MANUAL_DATA_UPDATE = 'API_MANUAL_DATA_UPDATE';
export const API_REQUEST_DELETE_DATA = 'API_REQUEST_DELETE_DATA';
export const API_REQUEST_RESET_ALL = 'API_REQUEST_RESET_ALL';
